import throttle from 'lodash.throttle';

export const stickyHeader = () => {
    (function (window, document) {
        const originHeader = document.querySelector('.js-globalHeader--origin') as HTMLElement | null;
        const stickyHeader = document.querySelector('.js-globalHeader--sticky') as HTMLElement | null;
        const hideStickyHeaderTarget = document.querySelectorAll('.js-hideStickyHeader');
        const intersectionObserverOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };

        if (!originHeader || !stickyHeader) return;

        const data = {
            fps: 1000 / 60,
            frameTicking: false,
            latestScrollTop: 0,
            hideTriggerTargetIsIntersecting: false,
            getOriginHeaderElementHeight: (): number => originHeader.clientHeight,
            getStickyHeaderElementHeight: (): number => stickyHeader.clientHeight,
            getLatestScrollTop: (): number => data.latestScrollTop,
            updateScrollAnimationFrameValues(scrollTop: number): void {
                data.frameTicking = false;
                data.latestScrollTop = scrollTop;
            },
            updateHideTriggerTargetIsIntersecting(isIntersecting: boolean): void {
                data.hideTriggerTargetIsIntersecting = isIntersecting;
            }
        };

        const methods = {
            /**
             * ヘッダーを画面外に隠す
             */
            hideStickyHeader(): void {
                stickyHeader.style.top = data.getStickyHeaderElementHeight() * -1 + 'px';
                stickyHeader.style.opacity = '0';
            },
            /**
             * ヘッダーを画面内に戻す
             */
            showStickyHeader(): void {
                stickyHeader.style.top = '0';
                stickyHeader.style.opacity = '1';
            },
            isStickyHeaderVisible(): boolean {
                const topPropValue = stickyHeader.style.top;
                return topPropValue === '0' || topPropValue === '0px';
            },
            isHideTriggerTargetIntersecting(): boolean {
                return data.hideTriggerTargetIsIntersecting;
            },
            controlStickyHeader(): void {
                const nowScrollTop: number = window.scrollY; // scrollTop = window.scrollY; https://developer.mozilla.org/ja/docs/Web/API/Window/scrollY

                /**
                 * スクロール量に変化が無かったときは処理を抜ける
                 */
                if (nowScrollTop === data.getLatestScrollTop() || 0 === data.getLatestScrollTop()) {
                    console.log('no scroll change');
                    data.updateScrollAnimationFrameValues(nowScrollTop);
                    return;
                }

                /**
                 * 非表示トリガーが表示されている場合は処理を抜ける
                 */
                if (methods.isHideTriggerTargetIntersecting()) {
                    console.log('hide because hide trigger target is intersecting');
                    methods.hideStickyHeader();
                    data.updateScrollAnimationFrameValues(nowScrollTop);
                    return;
                }

                /**
                 * stickyheaderを隠す制御
                 * 1. 下方向へのスクロールが行われた
                 * 2. originHeaderが画面内に表示されるような座標まで上スクロールが発生した
                 * 3. .js-hideStickyHeaderがviewport内に表示されている
                 */
                if (methods.isStickyHeaderVisible()
                    && (nowScrollTop > data.getLatestScrollTop() || nowScrollTop < data.getOriginHeaderElementHeight())) {
                    console.log('hide because scroll down');
                    methods.hideStickyHeader();
                    data.updateScrollAnimationFrameValues(nowScrollTop);
                    return;
                }

                /**
                 * stickyHeaderを表示させる制御
                 * 1. 最新のスクロール座標が、記録された前回のスクロール座標よりも小さかった(上方向へスクロール)
                 */
                if (!methods.isStickyHeaderVisible() && nowScrollTop < data.getLatestScrollTop()) {
                    console.log('show sticky header');
                    methods.showStickyHeader();
                    data.updateScrollAnimationFrameValues(nowScrollTop);
                    return;
                }

                /**
                 * fallback
                 */
                console.log('fallback because of unknown reason');
                data.updateScrollAnimationFrameValues(nowScrollTop);
                return;
            }
        };

        const handlers = {
            controlStickyHandler: () => {
                if (!data.frameTicking) {
                    window.requestAnimationFrame(methods.controlStickyHeader);
                    data.frameTicking = true;
                }
            },
            resizeObserveHandler: () => {
                // console.log('resize');
                methods.hideStickyHeader();
            }
        };
        // Register
        // Stickyfill.add(stickyHeader);
        window.addEventListener('scroll', throttle(handlers.controlStickyHandler, data.fps), {passive: false});
        window.addEventListener('resize', handlers.resizeObserveHandler, {passive: false});
        window.addEventListener('orientationchange', handlers.resizeObserveHandler, {passive: false});
        if (hideStickyHeaderTarget) {
            const intersectHandler = (entries) => {
                entries.forEach(entry => {
                    console.log(entry.isIntersecting);
                    data.updateHideTriggerTargetIsIntersecting(entry.isIntersecting);
                });
            };
            const observer = new IntersectionObserver(intersectHandler, intersectionObserverOptions);
            [...hideStickyHeaderTarget].forEach(target => {
                observer.observe(target);
            });
        }

        // Initialize
        if (stickyHeader.style.willChange !== 'top') {
            stickyHeader.style.willChange = 'top';
        }
        methods.hideStickyHeader(); // 初期状態では非表示にする
    })(window, document);
};
